import { FiltersConfig } from '../../../../../../../components/FilterGroup';

export const SPREADSHEETS_TABLE_FILTERS: FiltersConfig = {
  spreadsheetStatus: {
    title: 'Status',
    subTitle: 'Also applies to Download contacts',
    options: [],
  },
};
